import { useId } from 'react'

import { TeamOverview } from '@/interfaces/schema'
import Block from '@/layouts/block'
import PersonCard from '../cards/contact/person'
import { LoaderBlockEmployees } from '@/sections/rvdb/our-team/loader'
import { CTAStandardRvdbWhiteBgCard } from '@/components/cards'
import { UseOurTeamOutput } from '@/hooks/useOurTeam'
import { ButtonPrimary } from '@/components/button'

type EmployeeListProps = Pick<TeamOverview, 'ctaCard'> &
  Pick<
    UseOurTeamOutput,
    'filteredEmployees' | 'handleLoadMore' | 'totalCount'
  > & {
    loadingContent: boolean
    className?: string
  }

const EmployeeList = ({
  loadingContent,
  className = '',
  filteredEmployees,
  ctaCard,
  handleLoadMore,
  totalCount,
}: EmployeeListProps) => {
  const id = useId()

  if (loadingContent || !filteredEmployees) return <LoaderBlockEmployees />

  return (
    <>
      <Block
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-lg ${className}`}
      >
        {filteredEmployees &&
          filteredEmployees.map((employee, index) => {
            const {
              professionalImage,
              playfulImage,
              name,
              position,
              phoneNumber,
              emailAddress,
              linkedinLink,
            } = employee

            const personCardOrder = index + 1 < 6 ? index + 1 : index + 2
            return (
              <PersonCard
                order={personCardOrder}
                key={`${id}-${index}`}
                professionalImage={professionalImage}
                playfulImage={playfulImage}
                name={name}
                position={position}
                phoneNumber={phoneNumber}
                emailAddress={emailAddress}
                linkedinLink={linkedinLink}
              />
            )
          })}
        <CTAStandardRvdbWhiteBgCard
          className="order-5"
          title={ctaCard?.title ?? ''}
          description={ctaCard?.description ?? ''}
          buttonText={ctaCard?.buttonText ?? ''}
          buttonLink={ctaCard?.buttonPath ?? ''}
        />
      </Block>
      {totalCount !== filteredEmployees?.length && (
        <ButtonPrimary
          className="md:col-start-3 lg:col-start-5 col-span-2 md:col-span-4 lg:col-span-8 mx-auto"
          onClick={handleLoadMore}
        >
          Laad meer
        </ButtonPrimary>
      )}
    </>
  )
}

export default EmployeeList
